import React, { useState } from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

const ContentSection = ({ title, children, color = "#FF5722" }) => {
  const [isOpen, setIsOpen] = useState(true);
  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div
      style={{
        marginBottom: isOpen ? 24 : 12,
        transition: "margin-bottom 0.5s ease",
      }}
    >
      <div
        onClick={toggleOpen}
        style={{
          backgroundColor: color,
          color: "#fff",
          padding: "10px 16px",
          borderRadius: 6,
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: "bold",
        }}
      >
        <span>{title}</span>
        {isOpen ? <UpOutlined /> : <DownOutlined />}
      </div>

      {isOpen && <div style={{ marginTop: 16 }}>{children}</div>}
    </div>
  );
};

export default ContentSection;
